import { fromNullable } from 'fp-ts/lib/Option';

import type { FieldTypeEnum } from '../../model/domain/enum/FieldTypeEnum';
import type { TmplField } from '../../model/domain/TmplField';
import type { TmplFieldTO } from '../to/TmplFieldTO';

const toDomain = (to: TmplFieldTO): TmplField =>
  ({
    n: to.n,
    typ: to.typ as FieldTypeEnum,
    v: to.v,
    l: fromNullable(to.l),
    //extra values/words
    el: fromNullable(to.el),
    w: fromNullable(to.w),
    h: fromNullable(to.h),
    title: fromNullable(to.title),
    comment: fromNullable(to.comment),
  }) as TmplField;

export default {
  toDomain,
};
